var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "cancel-variant": "outline-secondary",
        centered: "",
        "ok-title": "저장",
        "cancel-title": "취소",
        size: "sm",
        title: _vm.isNew ? "항목 추가" : "항목 수정",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.submit()
        },
        close: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
        cancel: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
      },
      model: {
        value: _vm.showDeskDiseaseEdit,
        callback: function ($$v) {
          _vm.showDeskDiseaseEdit = $$v
        },
        expression: "showDeskDiseaseEdit",
      },
    },
    [
      _c(
        "validation-observer",
        { ref: "formRules" },
        [
          _c(
            "b-row",
            { staticClass: "mt-1" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "항목명", "label-for": "disease" } },
                    [
                      _c("validation-provider", {
                        attrs: { name: "항목명", rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "disease",
                                    placeholder:
                                      "항목명을 입력하세요.(최대 20자)",
                                    maxlength: "20",
                                    state: errors.length > 0 ? false : null,
                                  },
                                  model: {
                                    value: _vm.disease,
                                    callback: function ($$v) {
                                      _vm.disease = $$v
                                    },
                                    expression: "disease",
                                  },
                                }),
                                _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(errors[0])),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }